import {
  AbstractType,
  Injectable,
  InjectionToken,
  Injector,
  Type,
} from '@angular/core';
import { Observable } from '@app/shared/rx/rx-wrapper';
import { isFunction } from 'lodash';
import { IReplenishStrategyParams } from '../replenish.types';

@Injectable()
abstract class AbstractReplenishDataService<R = any> {
  public constructor(public injector: Injector) {}

  public inject<S>(
    token: Type<S> | InjectionToken<S> | AbstractType<S>,
    notFoundValue?: S,
  ): S {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }

  public abstract fetch(params: IReplenishStrategyParams): Observable<R>;
}

export { AbstractReplenishDataService };
